import { Select } from 'antd';
import React, { useEffect, useState } from 'react';

import { SelectProps } from 'antd/lib/select';
import { FeedType, Option } from '../../../types';
import { capitalizeFirstLetter } from '../../../utils';

export default function SelectFeedType({ ...props }: SelectProps<string, Option>): JSX.Element {
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (FeedType) {
      setOptions(
        Object.values(FeedType)
          .map((type): Option => ({ label: capitalizeFirstLetter(type), value: type.toLowerCase() })),
      );
    }
  }, []);

  return (
    <Select options={options} placeholder="Please select" allowClear {...props} />
  );
}
